import { css, keyframes } from "@emotion/react";
import { BG_NOTIFY } from "assets/Common";
import { theme } from "styles/theme";

const scrollingText = keyframes`
  0% {
    transform: translateX(30%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export const NotificationCustomStyle = {
  wrapper: css`
    min-width: 1200px;
    margin-top: 15px;
  `,
  item: css`
    background-image: url(${BG_NOTIFY});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 70px;
    box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25);
    overflow: hidden;
  `,
  text: css`
    overflow: hidden;
    width: 100%;
    margin: 0 10px;
    height: 100%;
    display: flex;
    span {
      overflow: hidden;
      white-space: nowrap;
      animation: ${scrollingText} 45s linear infinite;

      display: flex;
      min-width: max-content;
      gap: 200px;
      .width-text {
        min-width: max-content;
      }
      align-items: center;
      width: 100%;
      color: ${theme.colors.lightText};
    }
  `,
};
